// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__QHkiT","iconWrapper":"Link_iconWrapper__6rlX6"};